import { render, staticRenderFns } from "./ReactionsList.vue?vue&type=template&id=55a7741e&scoped=true"
import script from "./ReactionsList.vue?vue&type=script&lang=js"
export * from "./ReactionsList.vue?vue&type=script&lang=js"
import style0 from "./ReactionsList.vue?vue&type=style&index=0&id=55a7741e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7741e",
  null
  
)

export default component.exports